import React from 'react';
import { Badge, Button, Flashy, Icon, Tooltip } from '@axiom/ui';
import type { Opportunity } from '@axiom/validation';

import { TimeToSubmissionCopyUtil } from '../../utils/time-to-submission-copy-util';

import { WorkspaceTimeSubmissionTooltip } from './WorkspaceTimeSubmissionTooltip';

export const WorkspaceTimeToSubmission = ({
  opportunity,
}: {
  opportunity: Opportunity;
}) => {
  let badgeBackground: 'red' | 'yellow' | 'green' | 'light blue';
  switch (true) {
    case opportunity.timeToSubmission?.isSubmitted: {
      badgeBackground = 'light blue';
      break;
    }
    case typeof opportunity.timeToSubmission?.hours === 'number' &&
      opportunity.timeToSubmission.hours < 24: {
      badgeBackground = 'green';
      break;
    }
    case typeof opportunity.timeToSubmission?.hours === 'number' &&
      opportunity.timeToSubmission.hours >= 24 &&
      opportunity.timeToSubmission.hours < 48: {
      badgeBackground = 'yellow';
      break;
    }
    default: {
      badgeBackground = 'red';
      break;
    }
  }

  return (
    <Tooltip
      position="right"
      name="timeToSubmissionTooltip"
      anchor={
        <Button variation="minimal">
          <Badge background={badgeBackground} name="timeToSubmissionBadge">
            {TimeToSubmissionCopyUtil(opportunity)}
          </Badge>
          {!!(
            opportunity.timeToSubmission?.isSubmitted ||
            opportunity.firstCandidateSelectedOrFurtherAt
          ) && (
            <Flashy color="textDefault">
              <Icon name="checkmark" />
            </Flashy>
          )}
        </Button>
      }
    >
      <WorkspaceTimeSubmissionTooltip opportunity={opportunity} />
    </Tooltip>
  );
};
